/**
 * Croatian cardinal pluralisation bucket (mod-10 / mod-100 rules):
 *   1, 21, 31…  → 'one'   (bod / lokacija / minutu)
 *   2–4, 22–24… → 'few'   (boda / lokacije / minute)
 *   else        → 'other' (bodova / lokacija / minuta)
 * Non-finite or fractional counts fall back to 'other'.
 *
 * Single source of truth — consumers map the bucket onto their own
 * translation-key convention (e.g. 'many' or capitalised suffixes).
 */
export type CroatianPluralBucket = 'one' | 'few' | 'other';

export function croatianPluralBucket(
  count?: number | null
): CroatianPluralBucket {
  if (count == null || !isFinite(count)) return 'other';
  const abs = Math.abs(count);
  if (!Number.isInteger(abs)) return 'other';
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return 'one';
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'few';
  return 'other';
}
